import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { history } from "../utils";
import { fetchWrapper } from "../utils/fetch-wrapper";

const name = "auth";
const initialState = createInitialState();
const reducers = createReducers();
const extraActions = createExtraActions();
const extraReducers = createExtraReducers();

const slice = createSlice({ name, initialState, reducers, extraReducers });

export const authActions = { ...slice.actions, ...extraActions };
export const authReducer = slice.reducer;

function createInitialState() {
    return {
        accessToken: JSON.parse(localStorage.getItem("accessToken")),
        error: null,
    };
}

function createReducers() {
    return { logout };

    function logout(state) {
        state.accessToken = null;
        localStorage.removeItem("accessToken");
        history.navigate("/signin");
    }
}

function createExtraActions() {
    const baseUrl = `${process.env.REACT_APP_API_URL}/api`;
    return {
        login: login(),
    };

    function login() {
        return createAsyncThunk(
            `${name}/login`,
            async ({ username, password }) => {
                const response = await fetchWrapper.post(
                    `${baseUrl}/actionLogin.do`,
                    {
                        id: username,
                        password,
                        userSe: "USR",
                    }
                );

                return response;
            }
        );
    }
}

function createExtraReducers() {
    return {
        ...login(),
    };

    function login() {
        var { pending, fulfilled, rejected } = extraActions.login;

        return {
            [pending]: (state) => {
                state.error = null;
            },
            [fulfilled]: (state, action) => {
                const response = action.payload;
                const isLogin = response.isLogin;
                const accessToken = response.accessToken;

                if (isLogin === "Success") {
                    localStorage.setItem(
                        "accessToken",
                        JSON.stringify(accessToken)
                    );

                    state.accessToken = accessToken;

                    const { from } = history.location.state || {
                        from: { pathname: "/clip/gameCriteria" },
                    };

                    history.navigate(from);
                } else {
                    state.error = { message: "사용자 정보를 확인해 주세요" };
                }
            },

            [rejected]: (state, action) => {
                state.error = action.error;
            },
        };
    }
}
